export enum HeaderTypeEnum {
  WELCOME = 'Bem-vindo',
  CLOSURE = 'Encerramento',
  INACTIVITY_AUTO = 'Inatividade auto atendimento',
  OPENING_HOURS = 'Horário de funcionamento',
  INACTIVITY_CONTACT = 'Inatividade de contato',
}